import { updates } from '@/mocks/homeData';

const badgeColors: Record<string, string> = {
  '突发': 'bg-red-500',
  '追踪': 'bg-primary-500',
  '热议': 'bg-orange-500',
  '深扒': 'bg-accent-500',
  '独家': 'bg-secondary-500',
  '爆料': 'bg-pink-500',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              实时快讯
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              全天候滚动更新，第一时间掌握最新爆料
            </p>
          </div>

          <div className="relative pl-8 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-[2px] before:bg-background-300">
            {updates.map((item) => (
              <div key={item.id} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[23px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex items-start gap-3">
                  <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5 flex-shrink-0">{item.time}</span>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className={`px-1.5 py-0.5 text-[10px] font-medium text-background-50 rounded-sm whitespace-nowrap ${badgeColors[item.badge] || 'bg-background-400'}`}>
                        {item.badge}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}